import { TransformRule, TransformRuleData } from "./TransformRule";

export { Lowercase, LowercaseData };

type LowercaseData = {} & TransformRuleData;

class Lowercase extends TransformRule {
  constructor(data: LowercaseData) {
    super(data);
  }

  getDlfVariables() {
    return [];
  }

  getVariables() {
    return [];
  }

  isConfigured(): boolean {
    return true;
  }

  getRuleId(): string {
    return `${this.getDiscriminator()}-${this.fieldName}-${this.position}`;
  }

  toData(): LowercaseData {
    return {
      discriminator: this.discriminator,
      fieldName: this.fieldName,
      position: this.position,
    };
  }

  static createTest(rest: Partial<LowercaseData> = {}): Lowercase {
    const data: LowercaseData = {
      discriminator: "T_UCASE",
      fieldName: "",
      position: 0,
    };

    return new Lowercase({
      ...data,
      ...rest,
    });
  }
}
